// extracted by mini-css-extract-plugin
export default {"container":"fieldRow_container__0uhdo","label":"fieldRow_label__motOj","content":"fieldRow_content__JRJX6"};